import { getBootstrapData } from '@experience/core-hostapp-share-lib';
import { trackEvent } from '@/entities/sogu';
import { normalizeDisplayCurrencyIso } from '@/shared/lib/normalizeDisplayCurrencyIso';
import type { DisplayCurrencyIso } from '@/shared/types/displayCurrency';

const getCountryByIp = () => getBootstrapData().countryByIp ?? '';

const normalizeCurrency = (currency: DisplayCurrencyIso | string): string =>
  normalizeDisplayCurrencyIso(currency) ?? String(currency ?? '');

const buildCurrencyViewParams = (currency: DisplayCurrencyIso | string) => ({
  country_by_ip: getCountryByIp(),
  currency: normalizeCurrency(currency),
});

export function useDisplayCurrencyFilterSogu() {
  const trackDisplayCurrencyFilterView = (currency: DisplayCurrencyIso | string) => {
    return trackEvent('listing:filter:currency.view', buildCurrencyViewParams(currency));
  };

  const trackDisplayCurrencyFilterSelect = (
    currency: DisplayCurrencyIso | string,
    chosenCurrency: DisplayCurrencyIso | string,
  ) => {
    return trackEvent('listing:filter:currency.select', {
      ...buildCurrencyViewParams(currency),
      chosen_currency: normalizeCurrency(chosenCurrency),
    });
  };

  return {
    trackDisplayCurrencyFilterView,
    trackDisplayCurrencyFilterSelect,
  };
}
